import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'
import LoginPasswordScreen from '../screens/LoginPasswordScreen'
import { ensureUniversalLoginContext } from '@/utils/helpers/universalLoginContext.ts'

async function bootstrap() {
  await ensureUniversalLoginContext('login-password')
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <LoginPasswordScreen />
    </StrictMode>,
  )
}

bootstrap()
